import { Component, OnInit } from '@angular/core';
import { ColDef, ExcelExportParams, ExcelStyle, GridApi, GridReadyEvent, SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { HrmsService } from '../hrms.service';

@Component({
  selector: 'app-subject-details',
  templateUrl: './subject-details.component.html',
  styleUrls: ['./subject-details.component.scss']
})
export class SubjectDetailsComponent implements OnInit {
  private gridApi!: GridApi<any>;
  quickFilter: string = '';
  constructor(private spinner: NgxSpinnerService, private Service: HrmsService) { }
  ngOnInit(): void {
    this.hrmsSubjectDetails();
  }

  rowData: any[] = [];
  pinnedTopRowData: any[] = [];

  defaultExcelExportParams: ExcelExportParams = {
    exportAsExcelTable: true,
  };

  colDefs: ColDef<any>[] = [
    {
      field: 'subjectId', headerName: 'Subject Id',
      minWidth: 100,
      maxWidth: 100,
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'subjectName', headerName: 'Subject Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
  ]

  // default
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    menuTabs: [],
    suppressHeaderMenuButton: true,
  };
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
      type: "fitCellContents",
    };

  excelStyles: ExcelStyle[] = [
    {
      id: 'headerCell',
      font: { bold: true, size: 20 },
      alignment: { horizontal: 'Center', vertical: 'Center' },
    }
  ];


  hrmsSubjectDetails() {
    this.spinner.show();
    this.Service.getSubjectDetails().subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.rowData = res;
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  // onBtExport() {
  //   this.gridApi.exportDataAsExcel({
  //     fileName: 'HRMS_Subject_Details',
  //     sheetName: 'HRMS Subject Details',
  //   });
  //   alert("Execl Report genarated Please check the Download List")
  // }


  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'HRMS_Subject_Details',
      sheetName: 'HRMS Subject Details',

      prependContent: [
        {
          cells: [
            {
              styleId: 'headerCell',
              data: {
                type: 'String',   // ← old versions use plain string
                value: 'HRMS SUBJECT DETAILS REPORT'
              },
              mergeAcross: 2
            }
          ]
        },
        {
          cells: []  // blank row
        }
      ]
    };

    this.gridApi.exportDataAsExcel(params);
    alert("Excel Report generated. Please check Downloads.");
  }


  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
  }

  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }


}
